<template>
    <div class="modal-mask">
        <loader :loading="loading" v-if="loading" :fixed="true"></loader>
        <v-style>//body {overflow: hidden}</v-style>
        <div class="modal-wrapper">
            <div class="modal-container" :class="size">
                <div class="modalBody">
                    <img src="../../assets/croix.png" width="40" height="40" alt @click="close" class="cross fright abs pointer" />
                    <main :class="{ overlay }">
                        <div class="overlay-container"><slot name="overlay"></slot></div>
                        <slot name="main"></slot>
                    </main>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ModalBase from "@/components/modal/ModalBase";
import loader from "@/components/loader/loader";
export default {
    name: "ModalDefault",
    components: { ModalBase, loader },
    props: {
        loading: {
            required: false,
            type: Boolean,
            default: false
        },
        overlay: {
            required: false,
            type: Boolean,
            default: false
        },
        size: {
            required: false,
            type: String,
            default: "m"
        }
    },
    methods: {
        close() {
            this.$emit("close");
        }
    }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/media";
@import "../../assets/css/themes";
main {
    @extend %primary-text;
    @extend %primary-background;
    @extend %primary-border-color;
    border-width: 1px;
    border-style: solid;
    padding: 4%;
    width: 100%;
    overflow-y: auto;
    &.overlay {
        padding: 0;
        overflow: hidden;
        position: relative;
        .overlay-container {
            position: sticky;
            top: 0;
            left: 0;
            background-color: rgba(0, 0, 0, 0.9);
            width: 100%;
            height: 100%;
            z-index: 1;
        }
    }
}

.modal-mask {
    position: fixed;
    z-index: 250;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.7);
    display: block;
    transition: opacity 0.3s ease;
    overflow: auto;

    > .modal-wrapper {
        display: block;
        height: 100vh;
        width: 100%;

        > .modal-container {
            height: 100vh;
            margin: 0px auto;
            padding: 20px 30px;
            border-radius: 2px;
            box-shadow: none;
            transition: all 0.3s ease;
            font-family: Helvetica, Arial, sans-serif;
            position: relative;
            display: flex;
            align-items: center;

            &.xs {
                width: 25%;
                @media (max-width: 1440px) {
                    width: 50%;
                }
                @media (max-width: 1024px) {
                    width: 75%;
                }
                @media (max-width: 768px) {
                    width: 100%;
                }
            }

            &.s {
                width: 40%;
                @media (max-width: 1440px) {
                    width: 50%;
                }
                @media (max-width: 1024px) {
                    width: 75%;
                }
                @media (max-width: 768px) {
                    width: 100%;
                }
            }

            &.m {
                width: 50%;
                @media (max-width: 1024px) {
                    width: 75%;
                }
                @media (max-width: 768px) {
                    width: 100%;
                }
            }

            &.l {
                width: 75%;
                @media (max-width: 768px) {
                    width: 100%;
                }
            }

            &.xl {
                width: 100%;
            }

            .modalBody {
                width: 100%;
                max-height: 95vh;
                position: relative;

                .cross {
                    position: absolute;
                    top: 20px;
                    right: 20px;
                    z-index: 2;
                }

                .modal-title {
                    font-size: 32px;
                    font-family: "Oswald", Sans-Serif;
                    text-transform: uppercase;
                    margin-bottom: 20px;
                }
            }
        }
    }

    main {
        border-radius: 50px !important;
    }
}
</style>



// WEBPACK FOOTER //
// ModalDefault.vue?6844affb